// src/ARMERIX/MANAGEMENT/MANAGEMENTDASHBOARD/ManagementDashboard.tsx

import React, { useState } from "react";
import {
  Menu as MenuIcon,
  Storefront,
  SupportAgent,
  Home,
  EuroSymbol,
  Book,
} from "@mui/icons-material";
import { Drawer } from "@mui/material";
import { useNavigate } from "react-router-dom";

import logo from "../../../../assets/images/logo.png";
import GeneralCommercePartners from "../GENERALCOMMERCE/GeneralCommercePartners";
import CommerceManagementSupport from "../../SUPPORT/CommerceManagementSupport";
import Revenue from "../REVENUE/Revenue";
import Editorial from "../EDITORIAL/BLOG/Editorial";



const CommerceManagementDashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState("brands");
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();

  const renderContent = () => {
    switch (activeTab) {
      case "brands":
        return <GeneralCommercePartners />;
      case "support":
        return <CommerceManagementSupport />;
      case "revenue":
        return <Revenue />;
      
       case "editor":
        return <Editorial />;
        default:
        return <GeneralCommercePartners />;
    }
  };

  return (
    <div style={styles.page}>
      {/* HEADER */}
      <header style={styles.header}>
        <img src={logo} alt="Logo" style={styles.logo} />
        <button onClick={() => setMenuOpen(true)} style={styles.menuButton}>
          <MenuIcon fontSize="large" style={{ color: "#fff" }} />
        </button>
      </header>

      {/* TABS */}
      <div style={styles.tabsWrapper}>
        <div style={styles.tabsContainer}>
          <div style={styles.tabs}>

            {/* 🔹 Brands Tab */}
            <div
              style={
                activeTab === "brands"
                  ? styles.activeTab
                  : styles.tab
              }
              onClick={() => setActiveTab("brands")}
            >
              <Storefront style={styles.icon} />
              <span>Brands</span>
            </div>

               {/* 🔹 Brands Tab */}
            <div
              style={
                activeTab === "revenue"
                  ? styles.activeTab
                  : styles.tab
              }
              onClick={() => setActiveTab("revenue")}
            >
              <EuroSymbol style={styles.icon} />
              <span>Revenue</span>
            </div>

            {/* 🔹 Support Tab */}
            <div
              style={
                activeTab === "support"
                  ? styles.activeTab
                  : styles.tab
              }
              onClick={() => setActiveTab("support")}
            >
              <SupportAgent style={styles.icon} />
              <span>Support</span>
            </div>


                <div
              style={
                activeTab === "editor"
                  ? styles.activeTab
                  : styles.tab
              }
              onClick={() => setActiveTab("editor")}
            >
              <Book style={styles.icon} />
              <span>Edit</span>
            </div>

          </div>
        </div>

        <div style={styles.leftFade} />
        <div style={styles.rightFade} />
      </div>

      {/* CONTENT */}
      <div style={styles.content}>{renderContent()}</div>

      {/* DRAWER */}
      <Drawer
        anchor="right"
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
      >
        <div style={styles.drawer}>
          <div style={{ marginTop: 20 }} />

          <div
            style={styles.drawerItem}
            onClick={() => navigate("/")}
          >
            <Home style={{ marginRight: 10 }} />
            Home
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default CommerceManagementDashboard;

/* ---------------- STYLES ---------------- */

const styles: { [key: string]: React.CSSProperties } = {
  page: {
    background: "linear-gradient(90deg, #0A66C2 0%, #000000ff 60%)",
    color: "#fff",
    minHeight: "100vh",
  },

  header: {
    height: 70,
    background: "rgba(0,0,0,0.85)",
    backdropFilter: "blur(8px)",
    borderBottom: "1px solid rgba(255,255,255,0.1)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 20px",
    position: "sticky",
    top: 0,
    zIndex: 1000,
  },

  logo: { height: 40 },

  menuButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
  },

  tabsWrapper: {
    position: "relative",
    width: "100%",
    background: "#111",
    borderBottom: "1px solid #333",
    overflow: "hidden",
  },

  tabsContainer: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },

  tabs: {
    display: "flex",
    gap: "24px",
    padding: "12px 14px",
    overflowX: "auto",
    whiteSpace: "nowrap",
  },

  tab: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: "#aaa",
    fontSize: 13,
    cursor: "pointer",
    transition: "0.3s ease",
  },

  activeTab: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: "#0A66C2",
    fontWeight: "bold",
    fontSize: 13,
    cursor: "pointer",
  },

  icon: {
    fontSize: 26,
    marginBottom: 4,
  },

  content: {
    padding: 20,
  },

  drawer: {
    width: 260,
    background: "#000",
    color: "#fff",
    height: "100%",
    padding: "20px 10px",
  },

  drawerItem: {
    display: "flex",
    alignItems: "center",
    padding: "12px",
    cursor: "pointer",
    fontWeight: 600,
  },

  leftFade: {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    width: 40,
    background: "linear-gradient(to right, #000, transparent)",
    pointerEvents: "none",
  },

  rightFade: {
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,
    width: 40,
    background: "linear-gradient(to left, #000, transparent)",
    pointerEvents: "none",
  },
};
